import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { Error } from '../../shared/models/error.model';
import { RequestService } from '../../shared/services/request.service';
import { ReservationStatus } from './enums/reservation-status.enum';
import { ReservationAvailability } from './models/reservation-availability.model';
import { ReservationConfig } from './models/reservation-config.model';
import { Reservation } from './models/reservation.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ReservationService {

	constructor(private requestService: RequestService,
				private translateService: TranslateService) { }

	getReservationConfig(storeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId },
				APP_CONFIG.WEBSERVICE.GET_RESERVATION_CONFIG
			);
			this.requestService.getData(urlRequest).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	postReservationConfig(reservationConfig: ReservationConfig): Promise<any> {
		return new Promise((resolve, reject) => {
			this.requestService.postData(APP_CONFIG.WEBSERVICE.RESERVATION_CONFIG, reservationConfig.toJson()).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateReservationConfig(reservationConfig: ReservationConfig): Promise<any> {
		return new Promise((resolve, reject) => {
			this.requestService.putData(APP_CONFIG.WEBSERVICE.RESERVATION_CONFIG, reservationConfig.toJson()).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getReservationTables(storeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId },
				APP_CONFIG.WEBSERVICE.GET_RESERVATION_TABLES
			);
			this.requestService.getData(urlRequest).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});	
	}

	postReservationTables(daysOfWeek: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const days: any = JSON.parse(JSON.stringify(daysOfWeek));
			const jsonData: any = {
				storeId: days.storeId,
				daysList: []
			};
			days.daysList.forEach((d) => {
				if (d.enable) {
					jsonData.daysList.push({
						id: d.id,
						hourList: d.hourList,
						idDayOfWeek: d.idDayOfWeek
					});
				}
			});
			console.log(jsonData);
			this.requestService.postData(APP_CONFIG.WEBSERVICE.RESERVATION_TABLES, jsonData).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateReservationTables(tables: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.requestService.putData(APP_CONFIG.WEBSERVICE.RESERVATION_TABLES, tables).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	deleteReservationTables(storeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId},
				APP_CONFIG.WEBSERVICE.RESERVATION_TABLES
			);
			this.requestService.deleteData(urlRequest).then((response) => {
				resolve(response || null);
			}, (error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	//SECTORS
	postReservationSectors(storeId: number, sectors: any): Promise<any> {
		return new Promise((resolve, reject) => {		
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId},
				APP_CONFIG.WEBSERVICE.RESERVATION_SECTORS
			);	
			this.requestService.postData(urlRequest, sectors).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				if(error.status==412) {
					var errorMsg = error.message.split(":");
					error.message = this.translateService.instant(errorMsg[0], { value: errorMsg[1]||error.fullError.erros });
				}
				console.error(error);
				reject(error);
			});
		});
	}

	getReservationSectors(storeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId },
				APP_CONFIG.WEBSERVICE.RESERVATION_SECTORS+"?status=true"
			);
			this.requestService.getData(urlRequest).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});	
	}

	getReservationSectorsHours(storeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId },
				APP_CONFIG.WEBSERVICE.RESERVATION_SECTORS_HOURS
			);
			this.requestService.getData(urlRequest).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});	
	}

	postReservationSectorsHours(storeId: number, sectors: any): Promise<any> {
		return new Promise((resolve, reject) => {		
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId},
				APP_CONFIG.WEBSERVICE.RESERVATION_SECTORS_HOURS
			);	
			this.requestService.postData(urlRequest, sectors).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				if(error.status==412) {
					var errorMsg = error.message.split(":");
					error.message = this.translateService.instant(errorMsg[0], { value: errorMsg[1]||error.fullError.erros });
				}
				console.error(error);
				reject(error);
			});
		});
	}

	//TABLESCONF
	postTableConf(storeId: number, tableconf: any): Promise<any> {
		return new Promise((resolve, reject) => {		
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId},
				APP_CONFIG.WEBSERVICE.TABLES_CONF
			);	
			this.requestService.postData(urlRequest, tableconf).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getTableConf(storeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId },
				APP_CONFIG.WEBSERVICE.TABLES_CONF+"?status=true"
			);
			this.requestService.getData(urlRequest).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});	
	}

	getReservationAvailability(storeId: number, startDate: string, endDate: string): Promise<Array<ReservationAvailability>> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId, startDate: startDate, endDate: endDate },
				APP_CONFIG.WEBSERVICE.GET_RESERVATION_AVAILABILITY
			);
			this.requestService.getData(urlRequest).then((response: Array<ReservationAvailability>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateReservationAvailability(storeId: number, date: string, status: ReservationStatus): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = {
				store:{
					id: storeId
				},
				status: status,
				startDate: date,
				endDate: date
			};
			this.requestService.putData(APP_CONFIG.WEBSERVICE.RESERVATION_AVAILABILITY, data).then((response: Array<any>) => {
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getReservationList(storeId: number, status: string, typeOfQuery: string, reservationDate: string, size?: number, page?: number): Promise<Array<Reservation>> {
		return new Promise((resolve, reject) => {
			let urlRequest: string = "";
			switch (status) {
				case ReservationStatus.APPROVED:
					urlRequest = this.requestService.buildUrlPathParams({
						storeId: storeId,
						reservationDate: reservationDate,
						typeOfQuery: typeOfQuery
					}, APP_CONFIG.WEBSERVICE.GET_APPROVED_RESERVATION_LIST);
					break;

				case ReservationStatus.WAITING_APPROVAL:
					urlRequest = this.requestService.buildUrlPathParams({ storeId: storeId }, APP_CONFIG.WEBSERVICE.GET_WAITING_APPROVAL_RESERVATION_LIST);
					break;

				default: // CANCELED
					urlRequest = this.requestService.buildUrlPathParams(
						{ storeId: storeId, status: status, size: size, page: page }, 
						APP_CONFIG.WEBSERVICE.GET_CANCELED_RESERVATION_LIST
					);
					break;
			}
			this.requestService.getData(urlRequest).then((response: Array<any>) => {
				const responseReservations: Array<Reservation> = [];
				if (response && response.length > 0) {
					for (const r of response) {
						responseReservations.push(new Reservation(r));
					}
				}
				resolve(responseReservations);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			})
		})
	}

	cancelReservation(id: number, reason: string): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				id: id,
				noteReject: reason,
				customer: false
			}
			this.requestService.putData(APP_CONFIG.WEBSERVICE.CANCEL_RESERVATION, data).then((response: any) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getReservationsHoursAvailability(storeId: number, date: string): Promise<Array<{hour: string, quota: number}>> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams({
				storeId: storeId, 
				date: date
			}, APP_CONFIG.WEBSERVICE.GET_RESERVATION_HOURS_AVAILABILITY);
			this.requestService.getData(urlRequest).then((response: Array<any>) => {
				console.log(response);
				if (response && response.length > 0) {
					response.sort((h1, h2) => {
						return h1.hour > h2.hour ? 1 : -1;
					});
				}
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	createReservation(reservation: Reservation): Promise<void> {
		return new Promise((resolve, reject) => {
			console.log(reservation.toJsonCreate());
			this.requestService.postData(APP_CONFIG.WEBSERVICE.RESERVATION, reservation.toJsonCreate()).then((response: any) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateReservation(reservation: Reservation): Promise<void> {
		return new Promise((resolve, reject) => {
			console.log(reservation.toJsonUpdate());
			this.requestService.putData(APP_CONFIG.WEBSERVICE.RESERVATION, reservation.toJsonUpdate()).then((response: any) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	approveReservation(id: number, allowOverbooking?: boolean): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = { id: id };
			if (allowOverbooking) {
				data.allowOverbooking = true;
			}
			this.requestService.putData(APP_CONFIG.WEBSERVICE.APPROVE_RESERVATION, data).then((response: any) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	checkin(id: number, present: boolean): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = { id: id, present: present };
			this.requestService.putData(APP_CONFIG.WEBSERVICE.RESERVATION_CHECKIN, data).then((response: any) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	updateReservationConfigStatus(status): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.putData(APP_CONFIG.WEBSERVICE.RESERVATION_CONFIG_STATUS, status).then((response: any) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getReservationSummary(storeId: number, date: string): Promise<any> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams(
				{ storeId: storeId, date: date },
				APP_CONFIG.WEBSERVICE.RESERVATION_SUMMARY
			);
			this.requestService.getData(urlRequest).then((response: { approved: number, waitingApproval: number }) => {
				console.log(response);
				const reservationSummary: any = { };
				if (response && response.approved) {
					reservationSummary.approved = {
						amount: response.approved,
						description: ""
					};
					if (response.approved > 1) {
						reservationSummary.approved.description = "RESERVATION.RESERVATIONS_TODAY";
					} else {
						reservationSummary.approved.description = "RESERVATION.ONE_RESERVATIONS_TODAY";
					}
				} else {
					reservationSummary.approved = {
						amount: 0,
						description: "RESERVATION.NO_RESERVATIONS_TODAY"
					}
				}

				// Só mostra se existir
				if (response && response.waitingApproval) {
					reservationSummary.waitingApproval = {
						amount: response.waitingApproval,
						description: ""
					};
					if (response.waitingApproval > 1) {
						reservationSummary.waitingApproval.description = "RESERVATION.WAITING_APPROVAL_RESERVATIONS";
					} else {
						reservationSummary.waitingApproval.description = "RESERVATION.WAITING_APPROVAL_ONE_RESERVATIONS";
					}
				}
				resolve(reservationSummary);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/reservation.service.ts